// src/pages/ContactUsPage.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const ContactUsPage = () => {
  return (
    <>
      {/* Page Title Section */}
      <div className="wd-page-title page-title page-title-default title-size-default title-design-centered color-scheme-light">
        <div className="container">
          <h1 className="entry-title title">Contact us</h1>
          <nav className="wd-breadcrumbs">
            <span typeof="v:Breadcrumb">
              <Link to="/" rel="v:url" property="v:title">Home</Link>
            </span>
            <span className="wd-delimiter"></span>
            <span className="wd-last">Contact us</span>
          </nav>
        </div>
      </div>

      {/* Main Content Area for Contact Us */}
      <div className="wd-page-content main-page-wrapper">
        <main className="wd-content-layout content-layout-wrapper container" role="main">
          <div className="wd-content-area site-content">
            <article id="post-211" className="entry-content post-211 page type-page status-publish hentry">
              <div data-elementor-type="wp-page" data-elementor-id="211" className="elementor elementor-211">
                <section
                  className="wd-negative-gap elementor-section elementor-top-section elementor-element elementor-element-65d69f9e elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="65d69f9e" data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    {/* Address Column */}
                    <div className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-2cfc6365" data-id="2cfc6365" data-element_type="column">
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-element elementor-element-6a2c130d elementor-widget elementor-widget-wd_infobox" data-id="6a2c130d" data-element_type="widget" data-widget_type="wd_infobox.default">
                          <div className="elementor-widget-container">
                            <div className="info-box-wrapper">
                              <div className="wd-info-box text-left box-icon-align-top box-style-base color-scheme-">
                                <div className="info-box-content">
                                  <h4 className="info-box-title title box-title-style-underlined wd-fontsize-s" data-elementor-setting-key="title">
                                    ADDRESS
                                  </h4>
                                  <div className="info-box-inner reset-last-child" data-elementor-setting-key="content">
                                    <p>Virtual Wallet Systems Pvt Ltd.</p>
                                    <p>A 103, Block A, First Floor, Sector 63, Noida<br />First Floor, Unity Building, Noida 201301</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Phone Column */}
                    <div className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-1728fb05" data-id="1728fb05" data-element_type="column">
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-element elementor-element-4b503596 elementor-widget elementor-widget-wd_infobox" data-id="4b503596" data-element_type="widget" data-widget_type="wd_infobox.default">
                          <div className="elementor-widget-container">
                            <div className="info-box-wrapper">
                              <div className="wd-info-box text-left box-icon-align-top box-style-base color-scheme-">
                                <div className="info-box-content">
                                  <h4 className="info-box-title title box-title-style-underlined wd-fontsize-s" data-elementor-setting-key="title">
                                    PHONE
                                  </h4>
                                  <div className="info-box-inner reset-last-child" data-elementor-setting-key="content">
                                    <h3 className="elementor-icon-box-title">+91 971 603 3340</h3>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Email Column */}
                    <div className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-6ff79ac1" data-id="6ff79ac1" data-element_type="column">
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-element elementor-element-5cb712b0 elementor-widget elementor-widget-wd_infobox" data-id="5cb712b0" data-element_type="widget" data-widget_type="wd_infobox.default">
                          <div className="elementor-widget-container">
                            <div className="info-box-wrapper">
                              <div className="wd-info-box text-left box-icon-align-top box-style-base color-scheme-">
                                <div className="info-box-content">
                                  <h4 className="info-box-title title box-title-style-underlined wd-fontsize-s" data-elementor-setting-key="title">
                                    EMAIL
                                  </h4>
                                  <div className="info-box-inner reset-last-child" data-elementor-setting-key="content">
                                    <p>csupport@imw-edu.com</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                {/* Google Maps Section */}
                <section
                  className="wd-negative-gap elementor-section elementor-top-section elementor-element elementor-element-1ebcc4d7 wd-section-stretch-content elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="1ebcc4d7" data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-no">
                    <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-45af4094" data-id="45af4094" data-element_type="column">
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-element elementor-element-76e7b09 elementor-widget elementor-widget-google_maps" data-id="76e7b09" data-element_type="widget" data-widget_type="google_maps.default">
                          <div className="elementor-widget-container">
                            <div className="elementor-custom-embed">
                              {/* The src attribute is kept as per original HTML.
                                  For a real Google Maps embed, you'd typically use a proper embed URL
                                  from Google Maps or a React library. */}
                              <iframe loading="lazy"  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3513.2242539652487!2d77.375377!3d28.6209677!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5686e61f859%3A0xc98d30622a51d9f4!2sMaquCliste%20Infra%20LLP!5e0!3m2!1sen!2sin!4v1718614530000!5m2!1sen!2sin"  title="IMwalleT" aria-label="IMwalleT"></iframe>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </article>
          </div>
        </main>
      </div>
    </>
  );
};

export default ContactUsPage;
